angular
	.module 'App.Module.PriceRegion', []
	.config ($stateProvider, DEFAULT_RESOLVE_POLICY) ->
		$stateProvider
			.state 'price_region',
				url: '/price_regions',
				views:
					main:
						templateUrl: '@app/layout/views/app.entity-administration.view.html'
						controller: 'MainCrudController'
						controllerAs: 'mainCrud'

					"entity_search@price_region":
						templateUrl: '@app/layout/views/app.entity-search.view.html'
						controller: 'BaseSearchController'
						controllerAs: 'search'
				data:
					restrict: 'Backoffice.TopMenu.PriceRegion.Enabled'
					searchParams:
						repositoryName: 'PriceRegionRepository'
						title: 'wbo.title.price_region.list'
						createEnabled: ->
							return @ConfigurationService.isEnabled "Backoffice.Permission.PriceRegionCreation.Enabled"

			.state 'price_region.edit',
				url: '/:id'
				views:
					entity_view:
						templateUrl: '@app/layout/views/app.entity-container.view.html'
				resolvePolicy: DEFAULT_RESOLVE_POLICY
				resolve:
					currencies: (CurrencyRepository) ->
						query = do CurrencyRepository.createQuery
						query.withoutAnyRelations(true)

						return CurrencyRepository
							.findByQuery query
							.then (result) => result.data
					priceRegion: (PriceRegionRepository, $stateParams) ->
						return PriceRegionRepository.getEntity $stateParams.id
					vatRates: (VatRateRepository, ConfigurationService) ->
						if ConfigurationService.isEnabled 'Shared.Setting.VatRate.Enabled'
							return VatRateRepository.getEntities()
						return []

			.state 'price_region.edit.details',
				url: '/details',
				views:
					entity_sub_view:
						controller: 'PriceRegionController'
						controllerAs: 'vm'
						templateUrl: '@app/price-region/price-region.view.html'
